import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "feeding";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    fishMedicineList: [], //鱼药信息
    feedingList: {
      list: [],
      total: 0,
    },
  },
  actions: {
    //查询-----获取所有数据
    async getFeedingData ({ commit }, payload) {
      let result = await api.get(`/api/Feed?${queryString.stringify(payload)}`);
      if (result.status === 200) {
        commit("setFeedingList", result.data);
      }
      return result;
    },
    //查询-----获取所有数据
    async getFeedingDataV2 ({ commit }, payload) {
      let result = await api.get(
        `/api/Feed/GetFeedV2?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setFeedingList", result.data);
      }
      return result;
    },
    //添加
    async addFeeding (a, payload) {
      let result = await api.post("/api/Feed", payload);
      return result.data;
    },
    //删除数据
    async delFeeding (a, payload) {
      let result = await api.delete(`/api/Feed/` + payload);
      return result;
    },
    //删除子数据
    async delFeedingDetail (a, payload) {
      let result = await api.delete(`/api/Feed/Detail/` + payload);
      return result;
    },
    //编辑---获取单行数据
    async getEditFeeding (a, payload) {
      let result = await api.get(`/api/Feed/` + payload);
      return result.data;
    },
    //修改
    async updateFeeding (a, payload) {
      let result = await api.put(`/api/Feed/${payload.id}`, payload.data);
      return result.data;
    },
    //修改养殖周期（采购单自动生成的单据仅允许修改周期）
    async updateFeedingBatch (a, payload) {
      let result = await api.put(`/api/Feed/${payload.id}/Batch`, payload.data);
      return result.data;
    },
    //获取饲料来源
    async getFeedLeaderData ({ commit }, payload) {
      let result = await api.get(
        `api/Feed/Dropdown?typeId=7002&productId=${payload.productId}&FishBaseId=${payload.fishBaseId}`
      );
      return result.data;
    },
    //获取成本均价
    async getLayPrice ({ commit }, payload) {
      let result = await api.get(
        `/api/Product/GetMaterialPrice?productId=${payload.productId}&baseId=${payload.fishBaseId}`
      );
      return result.data;
    },
  },
  mutations: {
    setFishMedicineList (state, payload) {
      state.fishMedicineList = payload;
    },
    setFeedingList (state, payload) {
      state.feedingList = payload;
    },
  },
});

export default moduleName;
